<template>
  <article class="page-news-list-block">
    <!-- Image -->
    <div class="page-news-list-block__image">
      <NuxtLink
        :to="
          localePath({
            name: 'news-slug',
            params: { slug: props.news.slug },
          })
        "
        :data-hoverable="$t('cursor.read')"
      >
        <WidgetPicture
          :image="{
            custom: props.news.cover?.[0],
          }"
          :lazyLoad="true"
          :alt="props.news.cover?.[0]?.title"
        />
      </NuxtLink>
    </div>
    <div class="page-news-list-block__content m-top-16px">
      <!-- Header -->
      <header class="m-bottom-24px">
        <div class="page-news-list-block__content__preheader">
          <p class="text-s">{{ date }}</p>
          <p
            class="text-uppercase text-xs page-news-list-block__content__filters"
          >
            <strong
              v-for="(filter, index) in props.news.newsType"
              :key="index"
              >{{ $t(`filters.${filter}`) }}</strong
            >
          </p>
        </div>

        <NuxtLink
          :to="
            localePath({
              name: 'news-slug',
              params: { slug: props.news.slug },
            })
          "
          :data-hoverable="$t('cursor.read')"
        >
          <h2 class="title m-top-8px">{{ props.news.title }}</h2>
        </NuxtLink>
      </header>
      <!--Link 
      <WidgetLinkMainUnderline
        :link="{
          title: $t('pages.news.readNews'),
          route: { name: 'news-slug', params: { slug: props.news.slug } },
        }"
      /> -->
    </div>
  </article>
</template>

<script>
export default {
  name: 'PagesNewsListBlock',
}
</script>

<script setup>
const props = defineProps({
  news: Object,
})

const { locale } = useI18n()

const date = computed(() => {
  return new Intl.DateTimeFormat(locale.value).format(
    new Date(props.news.postDate)
  )
})
</script>

<style lang="scss">
@import './style.scss';
</style>
